import request from "@/utils/request";
import Qs from "qs";

const api = {
  queryPage: "/openapi/statistics/v1/resource/queryPage",
  query: "/openapi/statistics/v1/resource/query",
  resourceFile: "/openapi/statistics/v1/resource/resourceFile",
  resourceFiles: "/openapi/statistics/v1/resource/resourceFiles",
  exportDetail: "/openapi/statistics/v1/resource/exportDetail"
};

/**
 * 功能描述：资源上传统计分页查询 <br>
 * 〈〉
 * @Param
 *    page：查询页码【必填】
 *    rows：每页查询记录数【必填】
 *    workerName：查询名称【可选】
 *    stime：开始时间【可选】
 *    etime: 截至时间【可选】
 * @Return
 * @Author CHU
 * @Date 17:04 2021/1/26
 **/
export function queryPage(parameter) {
  return request({
    url: api.queryPage,
    method: "get",
    params: parameter
  });
}

/**
 * 功能描述：资源上传统计查询 <br>
 * 〈〉
 * @Param
 *    workerName：查询名称【可选】
 *    stime：开始时间【可选】
 *    etime: 截至时间【可选】
 * @Return
 * @Author CHU
 * @Date 17:19 2021/1/26
 **/
export function query(parameter) {
  return request({
    url: api.query,
    method: "get",
    params: parameter
  });
}

/**
 * 功能描述：资源文件列表查询 <br>
 * 〈〉
 * @Param 子任务id
 * @Return
 * @Author CHU
 * @Date 13:33 2021/1/29
 **/
export function resourceFile(parameter) {
  return request({
    url: api.resourceFile,
    method: "get",
    params: parameter
  });
}

/**
 * 功能描述：通过资源id字符串列表获取资源列表 <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 13:48 2021/3/2
 **/
export function resourceFiles(parameter) {
  return request({
    url: api.resourceFiles,
    method: "get",
    params: parameter
  });
}

/**
 * 功能描述：导出任务详细列表 <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 10:19 2021/3/19
 **/
export function exportDetail(parameter) {
  return request({
    url: api.exportDetail,
    method: "post",
    data: Qs.stringify(parameter)
  });
}
